var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrintTransparentBlue = function SvgPrintTransparentBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00588F",
    d: "M12.5 8.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m1-2.75V3.121a1.5 1.5 0 0 0-.44-1.06L11.44.439A1.5 1.5 0 0 0 10.378 0H3.453C2.926 0 2.5.448 2.5 1v4.5A2.5 2.5 0 0 0 0 8v4a.5.5 0 0 0 .5.5h2v3a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3h2a.5.5 0 0 0 .5-.5V8a2.5 2.5 0 0 0-2.5-2.5M4 1.5h6V3a.5.5 0 0 0 .5.5H12v2H4zm8 13H4v-2h8zm2.5-3.5h-13V8c0-.551.449-1 1-1h11c.551 0 1 .449 1 1z"
  })));
};
export default SvgPrintTransparentBlue;